import { IStudentSortListFilter } from "../typings/ISortList";
import http from "./client";

export interface IGetStudentsQueryParams {
  // sort: IStudentSortListFilter;
  search?: string;
  page?: number;
  limit?: number;
  course_id?: number | string;
  curator?: number | string  | 'none'; // id куратора
  tags?: Array<number | string>; // массив id тегов
  exclude_tags?: Array<number | string>; // массив id тегов
  exclude_document?: string | number;
  by_room?: number;
  lesson?: {
    id : number | string;
    status: 'inqueue' | 'done' | 'none'
  }
  type?: 'file';
  fileId?: string;
}

interface IStudentsResponse<T> {
  success: boolean;
  errorMessage?: string;
  paginator?: {
    limit: number;
    page: number;
    pageCount: number;
    totalItemCount: number;
  },
  metaData?: any;
  data?: Array<T>;
}

async function list<T> (filter: IGetStudentsQueryParams):Promise<IStudentsResponse<T>> {
  const resp = await http.get<IStudentsResponse<T>>('/api/student/list', {
    params: filter
  });

  return resp.data;
}
interface IInfoOkResponse {
  result: 'ok';
  message: 'ok';
  data?: {
    id: number
    name:string
    surname: string
  }
}

interface IInfoErrorResponse {
  result: 'error';
  message: string;
}

type TInfoResponse = IInfoOkResponse | IInfoErrorResponse

async function getInfo(params: {email: string, courseId?: number | string, groupId?: string | number, type?: string}): Promise<TInfoResponse> {
  const resp = await http.get('/api/students/getInfo', {
    params: {
      course_id: params.courseId,
      group_id: params.groupId,
      type: params.type,
      login: params.email,
    }
  });
  return resp.data;
}

const students = {
  list, getInfo
}


export default students;